import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import { useTranslation } from '@/i18n/hook';
import { faqItems } from '@/mocks/categories';
import { buildWebSiteSchema, buildOrganizationSchema, buildFaqPageSchema } from '@/seo/schema';
import HeroSection from './components/HeroSection';
import InfoSections from './components/InfoSections';
import CategoryGrid from './components/CategoryGrid';
import FeatureSections from './components/FeatureSections';
import PillarArticles from './components/PillarArticles';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const faqs = faqItems.map((item) => ({
    q: currentLang === 'de' ? item.questionDe : currentLang === 'en' ? item.questionEn : item.question,
    a: currentLang === 'de' ? item.answerDe : currentLang === 'en' ? item.answerEn : item.answer,
  }));

  const jsonLd = [
    buildWebSiteSchema(),
    buildOrganizationSchema(),
    buildFaqPageSchema(faqs),
  ];

  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main className="pt-16">
        <HeroSection />
        <InfoSections />
        <CategoryGrid />
        <FeatureSections />
        <PillarArticles />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}